(function ($) {
  'use strict';
  const menu = $('<ul></ul>');
  menu.append('<li><a id="scrollToTop" class="link">Allgemein</a></li>');

  $(document).ready(function () {
    $('.content-wrapper h2:not(".visually-hidden"):not(".hidden")').each(function (index, element) {
      //Do not show links to hidden webforms
      if ($(element).parent().css('display') === "none") {
        return;
      }
      const titleID = 'jumpMenu-' + index;
      $(this).attr('id', titleID);
      menu.append('<li><a class="link" href="#' + titleID + '">' + $(this).text().trim() + '</a></li>');
    });
    $('.page-menu').append(menu);

    $('.page-menu-trigger').on('click', function () {
      $(this).toggleClass('active');
      $('.page-menu-wrapper').toggleClass('open');
    });

    $('html').on('click', '.page-menu-wrapper a', function () {
      $('.page-menu-wrapper').removeClass('open');
      $('.page-menu-trigger').removeClass('active');
    });

    /**
     * On page load, check if anchor is set and scroll to target if exists.
     */
    if (window.location.href.split("#")[1] !== "") {
      const targetId = window.location.href.split("#")[1];
      if (targetId !== '') {
        const element = $(document).find("#" + targetId);
        if (element.length) {
          let scrollAmount = element.offset().top - 16;
          $('html, body').stop().animate({scrollTop: scrollAmount}, 500);
        }
      }
    }

    $('.page-menu-wrapper a').on('click', function (e) {
      const targetId = e.currentTarget.href.split("#")[1];
      if(e.currentTarget.id === "scrollToTop") {
        console.log(e.currentTarget.id)
        const element = $(document).find(".node > .content-wrapper > h1");
        console.log(element)
        if (element.length) {
          let scrollAmount = element.offset().top - 16;
          $('html, body').stop().animate({scrollTop: scrollAmount}, 500);
        }
      } else if (targetId !== '') {
        const element = $(document).find("#" + targetId);
        if (element.length) {
          let scrollAmount = element.offset().top - 16;
          $('html, body').stop().animate({scrollTop: scrollAmount}, 500);
        }
      }
    });
  });


})(jQuery);
